import { effect, inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

type BreakpointType = (typeof Breakpoints)[keyof typeof Breakpoints];

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  private breakpointObserver: BreakpointObserver = inject(BreakpointObserver);

  private observe(
    key: Lowercase<keyof typeof Breakpoints>,
    breakpoint: BreakpointType,
    initialValue: boolean = false,
  ): Signal<boolean> {
    return toSignal(
      this.breakpointObserver.observe(breakpoint).pipe(
        map((result: BreakpointState) => {
          if (result.matches) this.breakpoint.set(key);
          return result.matches;
        }),
      ),
      { initialValue },
    );
  }

  readonly breakpoint: WritableSignal<Lowercase<keyof typeof Breakpoints>> = signal('medium');
  readonly isSmallScreen: Signal<boolean> = this.observe('small', Breakpoints.Small);
  readonly isXSmallScreen: Signal<boolean> = this.observe('xsmall', Breakpoints.XSmall);
  readonly isMediumScreen: Signal<boolean> = this.observe('medium', Breakpoints.Medium, true);
  readonly isLargeScreen: Signal<boolean> = this.observe('large', Breakpoints.Large);
  readonly isXLargeScreen: Signal<boolean> = this.observe('xlarge', Breakpoints.XLarge);
}
